import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class EditPecMetadataModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$filter'
    ];

    private close: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $filter: ng.IFilterService
    ) {

        $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
        $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');

        $scope.item = $scope.$parent.$resolve.settings.item;

        $rootScope.formsubmitted = false;
        $scope.userIsSender = () => {
            return $rootScope.user.accountData.email === $scope.item.metadata.sender || $rootScope.user.accountData.PEC === $scope.item.metadata.sender;
        };
        $scope.userIsReceiver = () => {
            return $rootScope.user.accountData.email === $scope.item.metadata.primary_recipient || $rootScope.user.accountData.PEC === $scope.item.metadata.primary_recipient;
        };
        $scope.ok = () => {
            $scope.item.metadata.complete_status = 1;
            ArchiSmallServices.updatePECDocument($scope.item)
                .then((response) => {
                    this.close({ $value: response });
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };

        $scope.cancel = () => {
            this.close();
        };

    }
}

export const EditPecMetadataModalComponent: ng.IComponentOptions = {
    template: require('./edit-pec-metadata-modal.html'),
    controller: EditPecMetadataModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/edit-pec-metadata-modal/edit-pec-metadata-modal.ts